import styled from 'styled-components';
import { CSSVars } from '@/styles/styles.config';

export const StyledHero = styled.section`
  background: url(/assets/hero-bg.webp);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center 0%;
  color: ${CSSVars.white};
  padding: 140px 20px 140px;
  text-align: center;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 160px 40px 160px;
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 180px 40px 180px;
  }
`;

export const StyledHeroInner = styled.div`
  max-width: 800px;
  margin: 0 auto;
  position: relative;
`;

export const StyledH1 = styled.h1`
  font-size: 1.875rem;
  font-weight: 300;
  margin-bottom: 16px;
  line-height: 1.2;
  background: linear-gradient(277deg, #fff 48.61%, #808aad 109.97%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    font-size: ${CSSVars.fontSize2XL};
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    font-size: ${CSSVars.fontSize3XL};
  }
`;

export const StyledSubtitle = styled.p`
  font-size: ${CSSVars.fontSizeMD};
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.7;
  font-weight: 300;
  max-width: 620px;
  margin: 0 auto;
  position: relative;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    font-size: ${CSSVars.fontSizeLG};
  }
`;

export const StyledToolGrid = styled.section`
  background: ${CSSVars.white};
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  padding: 60px 20px 80px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px 100px;
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 100px 40px 120px;
  }
`;

export const StyledToolGridInner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledToolCard = styled.div<{ available: boolean }>`
  background: ${CSSVars.white};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: ${({ available }) => (available ? 1 : 0.5)};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

  ${({ available }) =>
    available &&
    `
    &:hover {
      border-color: rgba(76, 79, 255, 0.3);
      box-shadow: 0 6px 24px rgba(76, 79, 255, 0.1);
      transform: translateY(-2px);
    }
  `}

  .tool-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(76, 79, 255, 0.08);
    color: ${CSSVars.blue500};
    margin: 0 auto 16px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  h2 {
    font-size: ${CSSVars.fontSizeMD};
    font-weight: 700;
    color: ${CSSVars.black};
    margin-bottom: 6px;
    line-height: 1.3;
    text-align: center;
  }

  p {
    font-size: ${CSSVars.fontSizeSM};
    color: ${CSSVars.gray600};
    line-height: 1.6;
    font-weight: 300;
    flex: 1;
    text-align: center;
  }
`;

export const StyledCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: auto;
`;

export const StyledUseToolLink = styled.a`
  padding: 9px 18px;
  background: ${CSSVars.blue500};
  color: ${CSSVars.white};
  border: none;
  border-radius: 8px;
  font-size: ${CSSVars.fontSizeSM};
  font-weight: 700;
  text-decoration: none;
  transition: background 0.3s;

  &:hover {
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
  }
`;

export const StyledComingSoonBadge = styled.span`
  padding: 5px 12px;
  background: ${CSSVars.gray50};
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: ${CSSVars.gray500};
  border-radius: 8px;
  font-size: ${CSSVars.fontSizeXS};
  font-weight: 600;
`;
